import { MessagePathRecord } from "@/shared/domain/topics";
import {
  bigIntTimeToBigIntNanosec,
  numberTimeToBigIntNanosec,
  strTimeToBigIntNanosec,
  TimeUnit,
} from "@/shared/time";

const I64_CEIL = 2n ** 63n;
export const MIN_BIGINT = BigInt.asIntN(64, I64_CEIL); // -9223372036854775808n (wraps to min value)

const U64_CEIL = 2n ** 64n;
export const MAX_BIGINT = BigInt.asUintN(64, U64_CEIL - 1n); // 18446744073709551615n (2n ** 64n - 1n, the maximum non-wrapping value)

/**
 * Converts values read from a parquet timestamp column into a bigint timestamp value.
 */
export function toTimestamp(
  value: unknown,
  record: MessagePathRecord,
  defaultValue?: bigint,
): bigint {
  const units = timestampUnits(record);
  try {
    if (typeof value === "string") {
      return strTimeToBigIntNanosec(value, units);
    } else if (typeof value === "number") {
      return numberTimeToBigIntNanosec(value, units);
    } else if (value instanceof Date) {
      return numberTimeToBigIntNanosec(value.getTime(), "ms");
    } else {
      return bigIntTimeToBigIntNanosec(value as bigint, units);
    }
  } catch (err: unknown) {
    if (defaultValue !== undefined) {
      return defaultValue;
    }
    throw err;
  }
}

function timestampUnits(record: MessagePathRecord): TimeUnit {
  switch (record.metadata["unit"]) {
    case "s":
      return "s";
    case "ms":
      return "ms";
    case "us":
      return "us";
    case "ns":
    default:
      return "ns";
  }
}
